/**
 * Classify a 403 from the dashboard endpoint.
 *
 * A memorialist waiting on review is in a normal, temporary state, not a refusal.
 * The backend labels that case with a code so the portal can show it as a status
 * instead of "Le chargement a échoué. Vous n'avez pas l'autorisation de faire cela."
 */
export const MEMORIALIST_PENDING_REVIEW = 'acchub_memorialist_pending_review';

export type ForbiddenKind = 'pending-review' | 'error';

export type ForbiddenClassification = {
  kind: ForbiddenKind;
  message: string;
};

export const classifyDashboardForbidden = (
  payload: unknown,
  fallbackMessage: string,
): ForbiddenClassification => {
  let code = '';
  let message = '';

  if (payload && typeof payload === 'object') {
    const obj = payload as Record<string, unknown>;

    if (typeof obj.code === 'string') {
      code = obj.code;
    }

    if (typeof obj.message === 'string' && obj.message.trim().length > 0) {
      message = obj.message;
    } else if (obj.data && typeof obj.data === 'object') {
      const nested = (obj.data as Record<string, unknown>).message;
      if (typeof nested === 'string' && nested.trim().length > 0) {
        message = nested;
      }
    }
  }

  return {
    kind: code === MEMORIALIST_PENDING_REVIEW ? 'pending-review' : 'error',
    message: message === '' ? fallbackMessage : message,
  };
};
